import { useState, useCallback } from 'react';
import { OptionType } from '../../types/optionTypes';

export const useOptionModals = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState<OptionType | null>(null);

  // Show add modal
  const openAddModal = useCallback(() => {
    setShowAddModal(true);
  }, []);

  // Close add modal
  const closeAddModal = useCallback(() => {
    setShowAddModal(false);
  }, []);

  // Show delete confirmation
  const openDeleteModal = useCallback((option: OptionType) => {
    setDeleteConfirm(option);
  }, []);

  // Close delete confirmation
  const closeDeleteModal = useCallback(() => {
    setDeleteConfirm(null);
  }, []);

  return {
    // Modal states
    showAddModal,
    deleteConfirm,

    // Modal actions
    openAddModal,
    closeAddModal,
    openDeleteModal,
    closeDeleteModal,
  };
};
